import { Fragment, useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useSelector } from "react-redux"
import { calculateTotalByKey, funCheckNumber, selectFilter } from "../../Utility/utility"
import ExcelJS from 'exceljs';
import { saveAs } from "file-saver";
import { autoTable } from "jspdf-autotable"
import jsPDF from "jspdf";

import { useNavigate } from "react-router-dom"
import { Select, SelectItem } from "@heroui/react"
import { Chip } from "@mui/material"

const SinglePktLotWiseStockDetail = () => {
  const { compCode, compName } = useSelector((state) => state.company);
  const { stockLotNo } = useSelector((state) => state.stockEntry);
  const [selLotNos, setSelLotNos] = useState(new Set(stockLotNo?.lotnos || []))
  const [selAction, setSelAction] = useState(stockLotNo?.isInward || 0)
  const [data, setData] = useState([])
  const navigate = useNavigate();
  const [columnFilters, setColumnFilters] = useState({
    lotNo: "",
    pktNo: "",
    party: "",
    docNo: "",
    trnDate: "",
    mktNo: "",
    stkWeight: ""
  });

  const { data: masterData = [], mutate: filterLotNos } = usePost({
    url: apiRoute.stockEntry.getLotNosList,
    queryKey: "StockItemMaster",

  })

  const { lotdata = [], mutate: filterData } = usePost({
    url: apiRoute.stockEntry.fetchLotStockDetail,
    queryKey: "lotwisestockDetailtck",
    onSuccessTasks: (data) => {
      setData(data)
    }
  });

  useEffect(() => {
    const arr = [...selLotNos];
    if (arr.length > 0) {
      filterData({
        data: {
          comp_code: compCode.join(","),
          trade_of: "P",
          l_code: arr.join(","),
          is_inward: selAction,
          finw_date: selAction == 1 ? stockLotNo?.filters.fromDate : null,
          tinw_date: selAction == 1 ? stockLotNo?.filters.toDate : null


        }
      });
      filterLotNos({
        data: {
          comp_code: compCode.join(","),
          is_inward: selAction,
          from_date: selAction == 1 ? stockLotNo?.filters.fromDate : null,
          to_date: selAction == 1 ? stockLotNo?.filters.toDate : null
        }
      })
    }
    else {
      setData([])
    }

  }, [selLotNos, selAction]);

  const thClass =
    "border border-gray-300 px-2 py-1  text-center text-xs font-semibold leading-tight bg-slate-200";

  const tdClass =
    "border border-gray-300 px-1 py-1 text-center";

  const tdRight =
    "border border-gray-300 px-1 py-1 text-right";
  const stickyHeader =
    "sticky top-0 z-10  bg-gray-100 text-sm";

  const stickyFooter =
    "sticky bottom-0 z-10 bg-gray-200 font-semibold";

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    return d.toLocaleDateString("en-GB"); // dd/mm/yyyy
  };

  const filteredData = data.filter((row) => {
    const mktValue = `${row.L_Code}-${row.PktNo}`;
    return (
      (!columnFilters.lotNo ||
        row.SL_Code?.toLowerCase().includes(columnFilters.lotNo.toLowerCase())) &&

      (!columnFilters.pktNo ||
        row.SPktNo?.toLowerCase().includes(columnFilters.pktNo.toLowerCase())) &&

      (!columnFilters.docNo ||
        row.Bill_No?.toLowerCase().includes(columnFilters.docNo.toLowerCase())) &&
      (!columnFilters.party ||
        row.Party_Location?.toLowerCase().includes(columnFilters.party.toLowerCase())) &&
      (!columnFilters.trnDate ||
        row.Trn_Date?.toLowerCase().includes(columnFilters.trnDate.toLowerCase())) &&
      (!columnFilters.mktNo ||
        mktValue.toLowerCase().includes(columnFilters.mktNo.toLowerCase())) &&
      (!columnFilters.stkWeight ||
        String(row?.Stock_Weight)?.toLowerCase().includes(columnFilters.stkWeight.toLowerCase()))

    );
  });
  // Keeps original order but groups rows under lot
  const groupedData = filteredData.reduce((acc, row) => {
    const lotRaw = row.SL_Code || "UNKNOWN";
    const lotKey = lotRaw.toString().toUpperCase(); // case-insensitive key

    if (!acc[lotKey]) acc[lotKey] = [];
    acc[lotKey].push(row);

    return acc;
  }, {});


  // Object with lot totals
  const lotTotals = Object.fromEntries(
    Object.entries(groupedData).map(([lotNo, rows]) => {
      const totalPkt = rows.length;
      const totalInw = rows.reduce((t, r) => t + (r.Inw_Weight || 0), 0);

      const totalSaleWeight = rows.reduce((t, r) => t + (r.Sale_Weight || 0), 0);
      const totalSalePcs = rows.reduce((t, r) => t + (r.Sale_Pcs || 0), 0);

      const totalAmount = rows.reduce((t, r) => t + (r.Amount || 0), 0);
      const totalAmountD = rows.reduce((t, r) => t + (r.AmountD || 0), 0);
      let temp = totalAmount / totalSaleWeight
      const avgSaleRate = funCheckNumber(temp)
      temp = totalAmountD / totalSaleWeight
      const avgSaleRateD = funCheckNumber(temp)
      const totalMemoWeight = rows.reduce((t, r) => t + (r.Memo_Weight || 0), 0);
      const totalMemoPcs = rows.reduce((t, r) => t + (r.Memo_Pcs || 0), 0);
      const totalStock = rows.reduce((t, r) => t + (r.Stock_Weight || 0), 0);
      const totalStockPcs = rows.reduce((t, r) => t + (r.Stock_Pcs || 0), 0);
      return [
        lotNo,
        { totalInw, totalSaleWeight, totalAmount, totalAmountD, totalStock, totalMemoPcs, totalMemoWeight, totalPkt, totalSalePcs, avgSaleRate, avgSaleRateD, totalStockPcs }
      ];
    })
  );
  const handleClickPrev = () => {
    if (selAction == 1)
      navigate(linksUrl.rptSinglePktInwardStock);
    else
      navigate(linksUrl.rptSinglePktLotWiseStock);
  };
  const handleDelet = (key, name) => {

    const newFilter = selLotNos
    newFilter.delete(key)
    setSelLotNos(new Set(newFilter));

  }



  const exportToExcel = async () => {
    if (!data || data.length === 0) return;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Lot Stock Detail");

    /* ================= REPORT TITLE & DATE ================= */
    const reportTitle = "Single Packet Lot Wise Stock Detail";
    const companyName = compName.join(",")// Replace with dynamic if needed
    const today = new Date().toLocaleDateString("en-GB");

    const titleRow = worksheet.addRow([companyName]);
    worksheet.mergeCells(titleRow.number, 1, titleRow.number, 19);
    titleRow.font = { size: 14, bold: true };
    titleRow.alignment = { horizontal: "center", vertical: "middle" };

    const dateRow = worksheet.addRow([`${reportTitle} - (${today})`]);
    worksheet.mergeCells(dateRow.number, 1, dateRow.number, 19);
    dateRow.font = { bold: true };
    dateRow.alignment = { horizontal: "center", vertical: "middle" };

    worksheet.addRow([]); // Blank row

    /* ================= HEADER ================= */
    const header = [
      "Sr No", "Lot No", "Pkt No", "Mkt No", "Inw Date", "Inw Weight", "Inw Rate", "Inw Rate($)",
      "Mix-Sng Inw Weight", "Sale Weight", "Sale Pcs", "Sale Rate", "Sale Rate($)",
      "Sale Value", "Sale Value($)","Stock Weight", "Stock Pcs", "On Memo", "On Memo Pcs",
      "Trf To Mix", "Stock Location / Party", "Trn Date", "Doc No"
    ];

    const headerRow = worksheet.addRow(header);
    headerRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFD9E1F2" } };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" }
      };
    });

    /* ================= BODY ROWS ================= */
    Object.entries(groupedData).forEach(([lotNo, rows]) => {
      // Lot header
      const lotHeaderRow = worksheet.addRow([`Lot - ${lotNo}`]);
      lotHeaderRow.eachCell(cell => {
        cell.font = { bold: true, color: { argb: "FFC65911" } };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFFFF2CC" } };
        cell.alignment = { horizontal: "left" };
      });

      // Individual rows
      rows.forEach((row, i) => {
        const bodyRow = worksheet.addRow([
          i + 1,
          row.SL_Code,
          row.SPktNo,
          `${row.L_Code}-${row.PktNo}`,
          formatDate(row.Inw_Date),
          row.Inw_Weight || 0,
          row.Inw_Rate?.toFixed(2) || 0,
          row.Inw_RateD?.toFixed(2) || 0,
          row.MixSngInw_Weight || 0,
          row.Sale_Weight || "",
          row.Sale_Pcs || "",
          row.Sale_Rate?.toFixed(2) || "",
          row.Sale_RateD?.toFixed(2) || "",
          row.Amount?.toFixed(2) || "",
          row.AmountD?.toFixed(2) || "",
          row.Stock_Weight || 0,
          row.Stock_Pcs || 0,
          row.Memo_Weight || "",
          row.Memo_Pcs || "",
          row.TrfMix_Weight || "",
          row.Party_Location || "",
          formatDate(row.Trn_Date),
          row.Bill_No || ""
        ]);
        // --- Conditional Formatting ---
        let fillColor = null;
        if (row.Stock_Weight <= 0 && row.Memo_Weight <= 0) {
          fillColor = "FFFFC0CB"; // light pink
        } else if (row.Stock_Weight <= 0 && row.Memo_Weight > 0) {
          fillColor = "FFFFF2CC"; // light amber
        }
        bodyRow.eachCell(cell => {
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" }
          };
          cell.alignment = { horizontal: "center", vertical: "middle" };

          if (fillColor) {
            cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: fillColor } };
          }
        });
      });

      // Lot total
      const totals = lotTotals[lotNo];
      const lotTotalRow = worksheet.addRow([
        "",
        "Lot Total",
        totals.totalPkt,
        "",
        "",
        totals.totalInw,
        "",
        "",
        "",
        totals.totalSaleWeight,
        totals.totalSalePcs,
        totals.avgSaleRate,
        totals.avgSaleRateD,
        totals.totalAmount,
        totals.totalAmountD,
        totals.totalStock,
        totals.totalStockPcs,
        totals.totalMemoWeight,
        totals.totalMemoPcs,

      ]);

      lotTotalRow.eachCell(cell => {
        cell.font = { bold: true };
        cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFE7E6E6" } };
        cell.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" }
        };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });

      worksheet.addRow([]); // Blank row after each lot
    });

    /* ================= GRAND TOTAL ================= */
    const grandTotalRow = worksheet.addRow([
      "",
      data.length,
      "Grand Total",
      "",
      "",
      data.reduce((t, r) => t + (r.Inw_Weight || 0), 0),
      //  data.reduce((t, r) => t + (r.Inw_Pcs || 0), 0),
      "", "", "",
      data.reduce((t, r) => t + (r.Sale_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Sale_Pcs || 0), 0),
      "", "",
      data.reduce((t, r) => t + (r.Amount || 0), 0),
       data.reduce((t, r) => t + (r.AmountD || 0), 0),
      data.reduce((t, r) => t + (r.Stock_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Stock_Pcs || 0), 0),
      data.reduce((t, r) => t + (r.Memo_Weight || 0), 0),
      data.reduce((t, r) => t + (r.Memo_Pcs || 0), 0)
    ]);

    grandTotalRow.eachCell(cell => {
      cell.font = { bold: true };
      cell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FFC6E0B4" } };
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" }
      };
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });

    /* ================= COLUMN WIDTHS ================= */
    worksheet.columns = [
      { wch: 6 }, { wch: 10 }, { wch: 8 }, { wch: 10 },
      { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 10 },
      { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 },
      { wch: 22 }, { wch: 12 }, { wch: 10 },
      { wch: 20 }, { wch: 12 }, { wch: 10 }
    ];

    /* ================= SAVE FILE ================= */
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    const timestamp = new Date().toISOString().replace(/[-:.]/g, "").slice(0, 15);
    saveAs(blob, `Single_PktLot_Wise_Stock_Detail_${timestamp}.xlsx`);
  };


  // const exportToExcel = () => {
  //   if (!data || data.length === 0) return;

  //   const sheetData = [];
  //   const rowStyles = []; // Track row types

  //   /* ================= HEADER ================= */
  //   sheetData.push([
  //     "Sr No",
  //     "Lot No",
  //     "Pkt No",
  //     "Mkt No",
  //     "Inw Date",
  //     "Inw Weight",
  //     "Mix-Sng Inw Weight",
  //     "Sale Weight",
  //     "Sale Pcs",
  //     "Sale Rate",
  //     "Sale Value",
  //     "Stock Weight",
  //     "Stock Pcs",
  //     "On Memo",
  //     "On Memo Pcs",
  //     "Trf To Mix",
  //     "Stock Location / Party",
  //     "Trn Date",
  //     "Doc No",
  //   ]);
  //   rowStyles.push("header");

  //   /* ================= BODY ================= */
  //   Object.entries(groupedData).forEach(([lotNo, rows]) => {
  //     // Lot Header
  //     sheetData.push([`Lot - ${lotNo}`]);
  //     rowStyles.push("lotHeader");

  //     rows.forEach((row, i) => {
  //       sheetData.push([
  //         i + 1,
  //         row.SL_Code,
  //         row.SPktNo,
  //         `${row.L_Code}-${row.PktNo}`,
  //         formatDate(row.Inw_Date),
  //         row.Inw_Weight || 0,
  //         row.MixSngInw_Weight || 0,
  //         row.Sale_Weight || "",
  //         row.Sale_Pcs || "",
  //         row.Sale_Rate || "",
  //         row.Amount || "",
  //         row.Stock_Weight || 0,
  //         row.Stock_Pcs || 0,
  //         row.Memo_Weight || "",
  //         row.TrfMix_Weight || "",
  //         row.Party_Location || "",
  //         formatDate(row.Trn_Date),
  //         row.Bill_No || "",
  //       ]);
  //       rowStyles.push("normal");
  //     });

  //     // Lot Total
  //     const totals = lotTotals[lotNo];
  //     sheetData.push([
  //       "",
  //       "Lot Total",
  //       totals.totalPkt,
  //       "",
  //       "",
  //       totals.totalInw,
  //       "",
  //       totals.totalSaleWeight,
  //       totals.totalSalePcs,
  //       totals.avgSaleRate,
  //       totals.totalAmount,
  //       totals.totalStock,
  //       totals.totalStockPcs,
  //       totals.totalMemoWeight,
  //       totals.totalMemoPcs

  //     ]);
  //     rowStyles.push("lotTotal");

  //     sheetData.push([]);
  //     rowStyles.push("blank");
  //   });

  //   /* ================= GRAND TOTAL ================= */
  //   sheetData.push([
  //     "",
  //     data.length,
  //     "Grand Total",
  //     "",
  //     data.reduce((t, r) => t + (r.Inw_Weight || 0), 0),
  //     data.reduce((t, r) => t + (r.Inw_Pcs || 0), 0),
  //     "",
  //     data.reduce((t, r) => t + (r.Sale_Weight || 0), 0),
  //     data.reduce((t, r) => t + (r.Sale_Pcs || 0), 0),
  //     "",
  //     data.reduce((t, r) => t + (r.Amount || 0), 0),
  //     data.reduce((t, r) => t + (r.Stock_Weight || 0), 0),
  //     data.reduce((t, r) => t + (r.Stock_Pcs || 0), 0),
  //     data.reduce((t, r) => t + (r.Memo_Weight || 0), 0),
  //     data.reduce((t, r) => t + (r.Memo_Pcs || 0), 0),
  //   ]);
  //   rowStyles.push("grandTotal");

  //   /* ================= CREATE SHEET ================= */
  //   const ws = XLSX.utils.aoa_to_sheet(sheetData);

  //   /* ================= COLUMN WIDTH ================= */
  //   ws["!cols"] = [
  //     { wch: 6 }, { wch: 10 }, { wch: 8 }, { wch: 10 },
  //     { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 10 },
  //     { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 },
  //     { wch: 22 }, { wch: 12 }, { wch: 10 },
  //   ];

  //   /* ================= STYLES ================= */
  //   const styles = {
  //     header: {
  //       font: { bold: true },
  //       alignment: { horizontal: "center", vertical: "center" },
  //       fill: { fgColor: { rgb: "D9E1F2" } },
  //       border: fullBorder()
  //     },
  //     lotHeader: {
  //       font: { bold: true, color: { rgb: "C65911" } },
  //       fill: { fgColor: { rgb: "FFF2CC" } },
  //       alignment: { horizontal: "left" }
  //     },
  //     lotTotal: {
  //       font: { bold: true },
  //       fill: { fgColor: { rgb: "E7E6E6" } },
  //       border: fullBorder()
  //     },
  //     grandTotal: {
  //       font: { bold: true },
  //       fill: { fgColor: { rgb: "C6E0B4" } },
  //       border: fullBorder()
  //     },
  //     normal: {
  //       border: fullBorder()
  //     }
  //   };

  //   function fullBorder() {
  //     return {
  //       top: { style: "thin" },
  //       bottom: { style: "thin" },
  //       left: { style: "thin" },
  //       right: { style: "thin" }
  //     };
  //   }

  //   /* ================= APPLY STYLES ================= */
  //   const range = XLSX.utils.decode_range(ws["!ref"]);
  //   for (let R = range.s.r; R <= range.e.r; ++R) {
  //     for (let C = range.s.c; C <= range.e.c; ++C) {
  //       const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
  //       if (!ws[cellRef]) continue;

  //       const type = rowStyles[R];
  //       if (styles[type]) ws[cellRef].s = styles[type];
  //     }
  //   }

  //   /* ================= SAVE ================= */
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Lot Stock Detail");
  //   XLSX.writeFile(wb, "Single_PktLot_Wise_Stock_Detail.xlsx");
  // };

  const exportToPDF = () => {
    const doc = new jsPDF("landscape", "mm", "a4");

    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();

    const companyName = compName.join(",") // 🔹 replace dynamically if needed
    const reportTitle = "SINGLE PACKET LOT WISE STOCK DETAILS";

    // ================= TABLE HEADER =================
    const head = [[
      "Sr",
      "Lot No",
      "Pkt No",
      "Mkt No",
      "Inw Date",
      "Inw Wt",
      "Inw Rate",
      "Inw Rate($)",
      "Mix Inw Wt",
      "Sale Wt",
      "Sale Pcs",
      "Sale Rate",
      "Sale Rate($)",
      "Sale Amt",
      "Sale Amt($)",
      "Stock Wt",
      "Stock Pcs",
      "Memo Wt",
      "Memo Pcs",
      "Trf Mix",
      "Location / Party",
      "Trn. Date",
      "Doc No"
    ]];

    const body = [];

    // ================= TABLE BODY =================
    Object.entries(groupedData).forEach(([lotNo, rows]) => {
      // Lot Header
      body.push([
        {
          content: `Lot - ${lotNo}`,
          colSpan: 19,
          styles: {
            fontStyle: "bold",
            fillColor: [255, 242, 204],
            halign: "left"
          }
        }
      ]);

      rows.forEach((row, i) => {
        body.push([
          i + 1,
          row.SL_Code,
          row.SPktNo,
          `${row.L_Code}-${row.PktNo}`,
          formatDate(row.Inw_Date),
          row.Inw_Weight?.toFixed(2) || "",
          row?.Inw_Rate?.toFixed(2) || "",
          row?.Inw_RateD?.toFixed(2) || "",
          row.MixSngInw_Weight?.toFixed(2) || "",
          row.Sale_Weight?.toFixed(2) || "",
          row.Sale_Pcs || "",
          row.Sale_Rateany || "",
          row.Sale_RateD?.toFixed(2) || "",
          row.Amount?.toFixed(2) || "",
          row.AmountD?.toFixed(2)|| "",
          row.Stock_Weight?.toFixed(2) || "",
          row.Stock_Pcs || "",
          row.Memo_Weight?.toFixed(2) || "",
          row.Memo_Pcs || "",
          row.TrfMix_Weight?.toFixed(2) || "",
          row.Party_Location || "",
          formatDate(row.Trn_Date),
          row.Bill_No || ""
        ]);
      });

      // Lot Total
      const t = lotTotals[lotNo];
      body.push([
        { content: "Lot Total", colSpan: 3, styles: { fontStyle: "bold" } },
        t.totalPkt,
        "",
        t.totalInw.toFixed(2),
        "","","",
        t.totalSaleWeight.toFixed(2),
        t.totalSalePcs,
        t.avgSaleRate.toFixed(2),
        t.avgSaleRateD.toFixed(2),
        t.totalAmount.toFixed(2),
        t.totalAmountD.toFixed(2),
        t.totalStock.toFixed(2),
        t.totalStockPcs,
        t.totalMemoWeight.toFixed(2),
        t.totalMemoPcs,
        "",
        "",
        "",
        ""
      ]);
    });

    // ================= AUTO TABLE =================
    autoTable(doc, {
      startY: 20, // leave space for company header
      head,
      body,
      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 2,
        valign: "middle"
      },

      headStyles: {
        fillColor: [217, 225, 242],
        textColor: 0,
        fontStyle: "bold",
        halign: "center"
      },

      didDrawPage: (data) => {
        data.settings.margin.top = 20;
        // ===== COMPANY HEADER (REPEATS EVERY PAGE) =====
        doc.setFontSize(14);
        doc.setFont("helvetica", "bold");
        doc.text(companyName, pageWidth / 2, 10, { align: "center" });

        doc.setFontSize(10);
        doc.setFont("helvetica", "bold");
        doc.text(reportTitle, pageWidth / 2, 17, { align: "center" });

        doc.setFontSize(9);
        doc.text(
          `Date : ${new Date().toLocaleDateString("en-GB")}`,
          pageWidth - 15,
          10,
          { align: "right" }
        );

        // ===== FOOTER PAGE NUMBER =====
        const pageNo = doc.internal.getNumberOfPages();
        doc.setFontSize(8);
        doc.text(
          `Page ${pageNo}`,
          pageWidth - 15,
          pageHeight - 5,
          { align: "right" }
        );
      }
    });

    // ================= SAVE =================
    doc.save("Single_PktLot_Wise_Stock_Detail.pdf");
  };

  const filterThClass =
    "bg-gray-50  border-gray-300  border  px-1 py-1";

  const filterInputClass =
    "w-full px-1 py-[2px] text-[11px] border border-gray-400 rounded-sm " +
    "focus:outline-none focus:ring-1 focus:ring-orange-400 focus:border-orange-400 " +
    "placeholder-gray-400 bg-white";



  return (
    <MainContainer
      pageName="Single PAcket Lot Wise Details"
      breadcrumbs={["Reports", "Single Packet Lot Wise Details"]}
      prevPage={{ show: true, onClick: handleClickPrev }}
    >
      <div className="bg-white p-2 h-screen">
        <Select
          size="sm"
          name={"lcode"}
          label={"Select Lot Nos."}
          color="default"
          eventResizeFeature={true}
          selectionMode="multiple"
          labelPlacement="outside"
          showScrollIndicators={true}
          placeholder={"--select--"}
          className="w-full"
          classNames={{
            label: "text-xs font-semibold",
          }}
          variant="bordered"
          isVirtualized
          items={
            masterData && masterData.length > 0 ? masterData : []
          }
          onSelectionChange={setSelLotNos}
          selectedKeys={selLotNos}
          renderValue={(items) => {
            return (
              <div className="flex gap-2 w-full" >
                {items.map((item) => (
                  <div key={item.SL_Code} className="flex  text-xs">
                    <Chip
                      key={item.SL_Code}
                      label={item.data.SL_Code}
                      onDelete={() => handleDelet(item.key, 'lot')}
                      size="small"
                      color="secondary"
                      variant="outlined"
                      sx={{ height: 22, fontSize: "10px" }}
                    />
                    {/* <Chip size="sm" radius="sm" variant="flat" color="default" className="text-xs h-4" key={item.Q_Code}><strong style={{ fontSize: "0.6rem" }} className=" text-blue-800" > {item.data.Q_Name}</strong></Chip>
                                            <FontAwesomeIcon className="text-xs text-orange-700" onClick={() => handleDelet(item.key, 'purity')} icon={faCircleXmark} /></div> */}
                  </div>

                ))}
              </div>
            );
          }}
        >
          {(list) => (
            <SelectItem
              key={list.SL_Code}
            >
              {list.SL_Code}
            </SelectItem>
          )}
        </Select>
        <div className="flex justify-end my-2 gap-4">
          <button
            onClick={exportToExcel}
            className="px-3 py-1 text-xs bg-green-600 text-white rounded hover:bg-green-700"
          >
            Export Excel
          </button>
          <button
            onClick={exportToPDF}
            className="px-3 py-1 text-xs bg-red-600 text-white rounded hover:bg-green-700"
          >
            Export PDF
          </button>
        </div>
        <div className="border border-1 border-gray-400">
          <div className="overflow-auto max-h-[70vh] ">
            <table className="w-full border border-black  border-collapse text-[11px]">
              <thead className={stickyHeader}>
                <tr>
                  <th className={thClass}>Sr. No</th>
                  <th className={`${thClass} whitespace-nowrap`}>Lot No</th>
                  <th className={`${thClass} whitespace-nowrap`} >Pkt No</th>
                  <th className={`${thClass} whitespace-nowrap`}>Mkt No</th>
                  <th className={thClass}>Inw.<br />Date</th>
                  <th className={thClass}>Inw.<br />Weight</th>
                  <th className={thClass}>Inw.<br />Rate</th>
                  <th className={thClass}>Inw.<br />Rate($)</th>
                  <th className={thClass}>Mix-Sng<br />Inw. Weight</th>
                  <th className={thClass}>Sale<br />Weight</th>
                  <th className={thClass}>Sale<br />Pcs</th>
                  <th className={thClass}>Sale Rate</th>
                  <th className={thClass}>Sale Rate($)</th>
                  <th className={thClass}>Sale<br />Value</th>
                  <th className={thClass}>Sale<br />Value($)</th>
                  <th className={thClass}>Stock<br />Weight</th>
                  <th className={thClass}>Stock<br />Pcs</th>
                  <th className={thClass}>On Memo <br /> Weight</th>
                  <th className={thClass}>On Memo<br /> Pcs</th>
                  <th className={thClass}>Trf. To Mix</th>
                  <th className={thClass}>Stock location / Party</th>
                  <th className={thClass}>Trn.<br />Date</th>
                  <th className={thClass}>Doc. No</th>
                </tr>
                <tr>
                  <td colSpan={23} className="bg-slate-500">

                  </td>
                </tr>
                <tr>
                  <th className={filterThClass}></th>

                  <th className={filterThClass}>
                    <input
                      className={filterInputClass}
                      placeholder="Filter"
                      value={columnFilters.lotNo}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, lotNo: e.target.value })
                      }
                    />
                  </th>

                  <th className={filterThClass}>
                    <input
                      className={filterInputClass}
                      placeholder="Filter"
                      value={columnFilters.pktNo}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, pktNo: e.target.value })
                      }
                    />
                  </th>
                  <th className={filterThClass}>
                    <input
                      className={filterInputClass}
                      placeholder="Filter"
                      value={columnFilters.mktNo}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, mktNo: e.target.value })
                      }
                    />
                  </th>
                  <th className={filterThClass} colSpan={11}></th>
                  <th className={filterThClass}>
                    <input
                      className={`${filterInputClass} w-16`}
                      placeholder="Filter"
                      value={columnFilters.stkWeight}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, stkWeight: e.target.value })
                      }
                    />
                  </th>
                  {/* Skip columns you don’t want filter */}
                  <th className={filterThClass} colSpan={5}></th>
                  <th className={filterThClass}>
                    <input
                      className={filterInputClass}
                      placeholder="Filter"
                      value={columnFilters.party}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, party: e.target.value })
                      }
                    />
                  </th>
                  {/* <th className={filterThClass}>
                    {/* <input
                      className={filterInputClass}
                      value={columnFilters.trnDate}
                      placeholder="Filter"
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, trnDate: e.target.value })
                      }
                    /> 
                  </th> */}
                  <th className={filterThClass}>
                    <input
                      className={filterInputClass}
                      placeholder="Filter"
                      value={columnFilters.docNo}
                      onChange={(e) =>
                        setColumnFilters({ ...columnFilters, docNo: e.target.value })
                      }
                    />
                  </th>
                </tr>
                <tr>
                  <td colSpan={23} className="bg-slate-500 ">

                  </td>
                </tr>
              </thead>

              <tbody>
                {Object.entries(groupedData).map(([lotNo, rows]) => {
                  // Calculate lot-wise totals
                  const totalInw = rows.reduce((t, r) => t + (r.Inw_Weight || 0), 0);
                  const totalSaleWeight = rows.reduce((t, r) => t + (r.Sale_Weight || 0), 0);
                  const totalAmount = rows.reduce((t, r) => t + (r.Amount || 0), 0);
                  const totalStock = rows.reduce((t, r) => t + (r.Stock_Weight || 0), 0);

                  return (
                    <Fragment key={lotNo}>
                      {/* Lot Header */}
                      <tr className="bg-orange-50 text-sm text-orange-600 font-semibold">
                        <td className={tdClass} colSpan={23}>
                          Lot - {lotNo}
                        </td>
                      </tr>

                      {/* Lot Rows */}
                      {rows.map((row, i) => (
                        <tr key={i} className={`${row.Stock_Weight <= 0 && row.Memo_Weight <= 0 ? 'bg-pink-50' : row.Stock_Weight <= 0 && row.Memo_Weight > 0 ? 'bg-amber-50' : ''} even:bg-grayy-50`}>
                          <td className={tdRight}>{i + 1}</td> {/* Sr. No */}
                          <td className={tdClass}>{row.SL_Code}</td>
                          <td className={tdClass}>{row.SPktNo}</td>
                          <td className={tdClass}>{row.L_Code + "-" + row.PktNo}</td>
                          <td className={tdRight}>{formatDate(row.Inw_Date)}</td>
                          <td className={tdRight}>{row.Inw_Weight?.toFixed(2)}</td>
                          <td className={tdRight}>{row.Inw_Rate?.toFixed(2)}</td>
                          <td className={tdRight}>{row.Inw_RateD?.toFixed(2)}</td>
                          <td className={tdClass}>{row.MixSngInw_Weight?.toFixed(2)}</td>
                          <td className={tdRight}>{row.Sale_Weight.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Sale_Pcs || ""}</td>
                          <td className={tdRight}>{row.Sale_Rate?.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Sale_RateD?.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Amount?.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.AmountD?.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Stock_Weight.toFixed(2)}</td>
                          <td className={tdRight}>{row.Stock_Pcs}</td>
                          <td className={tdRight}>{row.Memo_Weight.toFixed(2) || ""}</td>
                          <td className={tdRight}>{row.Memo_Pcs || ""}</td>
                          <td className={tdClass}>{row.TrfMix_Weight.toFixed(2)}</td>
                          <td className={tdClass}>{row.Party_Location}</td>
                          <td className={tdClass}>{formatDate(row.Trn_Date)}</td>
                          <td className={tdClass}>{row.Bill_No}</td>
                        </tr>
                      ))}

                      {/* Lot Total Row
                    <tr className="bg-gray-300 font-semibold">
                      <td className={tdRight} colSpan={4}>Lot Total</td>
                      <td className={tdRight}>{totalInw.toFixed(2)}</td>
                      <td className={tdClass}></td>
                      <td className={tdRight}>{totalSaleWeight.toFixed(2)}</td>
                      <td className={tdClass}></td>
                      <td className={tdRight}>{totalAmount.toFixed(2)}</td>
                      <td className={tdRight}>{totalStock.toFixed(2)}</td>
                      <td colSpan={5} className={tdClass}></td>
                    </tr> */}
                    </Fragment>
                  );
                })}
              </tbody>
              {/* FOOTER */}
              <tfoot className={stickyFooter}>
                {Object.entries(lotTotals).map(([lotNo, totals]) => (
                  <tr key={lotNo} className=" bg-orange-50 text-orange-600  text-sm font-semibold">
                    <td className="text-center" colSpan={3}>Total (Lot- {lotNo})</td>
                    <td className="text-center" >{totals.totalPkt}</td>
                    <td className="text-center" ></td>
                    <td className={tdRight}>{totals.totalInw.toFixed(2)}</td>
                    <td className={tdRight}></td>
                    <td className={tdRight}></td>
                    <td className={tdRight}></td>
                    <td className={tdRight}>{totals.totalSaleWeight.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalSalePcs}</td>
                    <td className={tdRight}>{totals.avgSaleRate.toFixed(2)}</td>
                    <td className={tdRight}>{totals.avgSaleRateD.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalAmount.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalAmountD.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalStock.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalStockPcs}</td>
                    <td className={tdRight}>{totals.totalMemoWeight.toFixed(2)}</td>
                    <td className={tdRight}>{totals.totalMemoPcs}</td>
                    <td className={tdRight} colSpan={4}></td>

                  </tr>
                ))}
                <tr className="bg-gray-300 text-sm">
                  <td className={tdRight} colSpan={5}>Grand Total</td>
                  <td className={tdRight}>
                    {filteredData.reduce((t, r) => t + (r.Inw_Weight || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdClass}></td>
                  <td className={tdClass}></td>
                  <td className={tdClass}></td>

                  <td className={tdRight}>
                    {filteredData.reduce((t, r) => t + (r.Sale_Weight || 0), 0).toFixed(2)}
                  </td>

                  <td className={tdClass}></td>
                  <td className={tdClass}></td>
                  <td className={tdClass}></td>
                  <td className={tdRight}>
                    {filteredData.reduce((t, r) => t + (r.Amount || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdRight}>
                    {filteredData.reduce((t, r) => t + (r.AmountD || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdRight}>
                    {filteredData.reduce((t, r) => t + (r.Stock_Weight || 0), 0).toFixed(2)}
                  </td>
                  <td className={tdClass}></td>
                  <td colSpan={10} className={tdClass}></td>
                </tr>
              </tfoot>




            </table>


          </div>
        </div>
      </div>
    </MainContainer>
  );
};

export default SinglePktLotWiseStockDetail;
